import { Button, ButtonGroup } from '@material-ui/core';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import React from 'react';
import ApplyRounding from '../math/ApplyRounding';
import Repeatable from 'react-repeatable';

const buttonStyle = (color) => {
  return {
    color: color,
    height: 20,
    minWidth: 1,
    maxWidth: 2,
    backgroundColor: 'blue',
  };
};
export default function IncrementDecrementButtonGroup({
  setter,
  currentValue,
  incrementAmount,
  roundDecimals,
  isHorizontal,
}) {
  return (
    <ButtonGroup orientation={isHorizontal ? 'horizontal' : 'vertical'}>
      <Repeatable
        //  tag={"button"}
        // type={"button"}
        onHold={() => {
          setter(ApplyRounding(currentValue + incrementAmount, roundDecimals));
        }}
      >
        <Button
          style={buttonStyle('green')}
          onClick={(ev) =>
            setter(ApplyRounding(currentValue + incrementAmount, roundDecimals))
          }
        >
          <ArrowDropUp />
        </Button>
      </Repeatable>
      <Repeatable
        onHold={() => {
          if (currentValue === 0) {
            return;
          }
          setter(ApplyRounding(currentValue - incrementAmount, roundDecimals));
        }}
      >
        <Button
          style={buttonStyle('red')}
          onClick={(ev) => {
            if (currentValue === 0) {
              return;
            }
            setter(
              ApplyRounding(currentValue - incrementAmount, roundDecimals)
            );
          }}
        >
          <ArrowDropDown />
        </Button>
      </Repeatable>
    </ButtonGroup>
  );
}
